import { MediaItem } from "Interfaces/general.interface";
import { BackColor } from "Interfaces/general.interface";
import { LinkItem } from "Interfaces/general.interface";

import ComponentImage from "GeneralComponents/ComponentImage";
import ContentBtn from './TextHolderBoxButton';
import ContentTitle from './TextHolderTitle';
import ContentDescription from './TextHolderDescription';
import useTextHolder from './useTextHolder';

import './TextHolderBg.min.css';

interface Props {
    id: string;
    title: string;
    shortDescription: string;
    description: string;
    desktopImage: MediaItem;
    mobileImage: MediaItem;
    icon: string;
    backGround: BackColor;
    changeImagePosition: boolean;
    dir: string;
    linkBtn: LinkItem;
    componentType: string;
    shadowColor: string;
    showSmallImage: string;
    alignTextToRL: string;
    changeButtonPosition: string;
};

const mediaTypeLarge = window.matchMedia("(min-width: 1024px)");

const TextHolderBox: React.FC<Props> = (props) => {

    const { backGround, alignTextToRL, changeImagePosition, changeButtonPosition, componentType, description, desktopImage, icon, linkBtn, mobileImage, shadowColor, title, showSmallImage } = props;
    const { COMPONENT_TYPES, SHADOW_COLORS, getOpacityBackground } = useTextHolder();
    const isTextHolderWithBG = componentType === COMPONENT_TYPES.BG;
    const isWhiteTextOnBgOpacity = isTextHolderWithBG && (shadowColor !== SHADOW_COLORS.Light);
    const isWhiteTextOnRegularBg = backGround && !isTextHolderWithBG && backGround.Type == "dark";
    const isTextCentered = (!desktopImage.url && !alignTextToRL && mediaTypeLarge.matches) || (!mediaTypeLarge.matches && !alignTextToRL);
    const isBtnSetToTop = !!(!desktopImage.url && alignTextToRL && changeButtonPosition);
    const hasCollapseBtn = (description && linkBtn.url == '' && !isTextHolderWithBG);
    const copyRight = (!mediaTypeLarge.matches && mobileImage.url) ? mobileImage.copyRight : desktopImage.copyRight;
    const colWidth = !!desktopImage.url ? "col-lg-6" : "col-lg-12";

    return (
        <div className={`container TextHolder 
            ${getOpacityBackground(shadowColor)}
            ${(isWhiteTextOnBgOpacity || isWhiteTextOnRegularBg) ? "white-txt" : ""}`}>

            <div className="row d-flex">

                <div className={`col-12 px-md-auto align-self-center ${colWidth} pl-lg-5`}>

                    <ContentTitle
                        hasImg={!!desktopImage.url}
                        icon={icon}
                        title={title}
                        isTextCentered={false}
                    />
                    <div className={isBtnSetToTop? 'd-md-flex d-block gap-4 justify-content-between': 'pt-2  d-md-block arimo content-txt w-100 mb-4'}>

                        <ContentDescription
                            {...props}
                            isTextCentered={false}
                            isTextHolderWithBG={isTextHolderWithBG}
                        />
                    </div>

                    <ContentBtn
                        {...props}
                        isBtnCentered={isTextCentered}
                        isTextHolderWithBG={isTextHolderWithBG}
                        hasCollapseBtn={hasCollapseBtn}
                        hasLinkBtn={!!linkBtn.url}
                    />

                </div>

                {
                    desktopImage.url &&

                    <div className={`mst-img-container col-12 col-lg-6 d-md-flex order-first
                        order-lg-${!!changeImagePosition ? "first" : "last"}
                        justify-content-${changeImagePosition ? 'start' : 'end'}`
                        }>

                        <ComponentImage
                            image={desktopImage}
                            imageClass="mst-textholder-img"
                            mobileImage={mobileImage}
                            mobileImageClass="mb-3 mst-textholder-mobile-img w-auto"
                            videoControls={true}
                            videoAutoplay={false}
                            wrapperDivClass={`mst-img-aria text-center w-auto  
                                ${desktopImage.isImage ? "" : "mst-img-aria-autoHeight"}
                                ${!!showSmallImage && desktopImage.isImage? "mst-img-aria--sm" : ""}
                                `}
                        />
                       {/* {copyRight && < div className="imgCopyRight"> &#169; {copyRight}</div>}*/}
                         
                    </div>
                }

            </div>

        </div>
    );

}

export default TextHolderBox;